import styled from 'styled-components';
import Icon from '../../assets/images/mfa.svg';

interface MfaIconProps {
  fill: string;
}

const MfaIcon = styled.span<MfaIconProps>`
  ${({fill}) => `
        background-color: ${fill};
        display: inline-block;
        height: 44px;
        mask-image: url(${Icon});
        mask-position: center center;
        mask-repeat: no-repeat;
        mask-size: 100%;
        position:relative;
        width: 36px;
    `}
`;

export default MfaIcon;
